module.exports = __webpack_public_path__ + "static/media/bolt.9bd9c19b.svg";